import { render, staticRenderFns } from "./PageSixElite.vue?vue&type=template&id=8147b544&scoped=true"
import script from "./PageSixElite.vue?vue&type=script&lang=js"
export * from "./PageSixElite.vue?vue&type=script&lang=js"
import style0 from "./PageSixElite.vue?vue&type=style&index=0&id=8147b544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8147b544",
  null
  
)

export default component.exports